import * as type from "./types"

export const fetchFaqData = () => {
    return { type: type.FAQ_LIST_REQUEST, payload: null }
}

export const resetFaqData = () => {
    return { type: type.RESET_FAQ_LIST, payload: null }
}